module.exports = __webpack_public_path__ + "img/hiroshima_hgh.e67dad14.jpg";